/**
 * Handles interaction with Gravity form text input fields.
 *
 * When a gravity forms field receives focus, the label is
 * moved to reveal the input contents with CSS.
 *
 * This module adds/removes a class to field wrappers based
 * on whether a user has entered a value in any input they
 * house. The class keeps the label fixed in place above the
 * input, so as not to obscure its contents.
 */

const isIE11 = () => window.navigator.userAgent.match(/MSIE|Trident/) !== null;

const HAS_VALUE_CLASS = 'has-value';
const INPUT_SELECTOR = 'input, textarea';

class GravityFormsInputLabels {
  constructor(gravityFormFieldClass) {
    this.fields = [...document.querySelectorAll(gravityFormFieldClass)];
    this.init();
  }

  init() {
    // IE11 doesn't support the :focus-within pseudo class, which this animation relies on.
    // Make all inputs static as a fallback.
    if (isIE11()) {
      this.fields.forEach(({ classList }) => classList.add(HAS_VALUE_CLASS));
      return;
    }

    this.fields.forEach(field => {
      /**
       * Update field labels on load to catch
       * any cached values.
       */
      this.handleChange(field);

      field.addEventListener('change', () => this.handleChange(field));
    });
  }

  /**
   * Add class to field if any of its children inputs
   * have value.
   *
   * @param {HTMLElement} field GF field
   */
  handleChange(field) {
    const inputs = [...field.querySelectorAll(INPUT_SELECTOR)];
    const anyInputHasValue = inputs.some(input => input.value);

    if (anyInputHasValue) {
      field.classList.add(HAS_VALUE_CLASS);
    } else {
      field.classList.remove(HAS_VALUE_CLASS);
    }
  }
}

export default GravityFormsInputLabels;
